export interface IncomingOrdersStatistics {
    total: number;
    orders: OrderDatePairs[];
}

export interface OrderDatePairs {
    key: string; // Date in ISO format
    value: number; // Count of orders for that date
}

export const defaultIncomingOrdersStatistics: IncomingOrdersStatistics = {
    total: 0,
    orders: []
};